// extracted by mini-css-extract-plugin
module.exports = {"donut":"donut_donut__1TDuw","donut_size":"donut_donut_size__1GPbM","pie":"donut_pie__1bWkM","spin":"donut_spin__2mFEW"};